// src/pages/Login.jsx

import React from "react";
import LoginForm from "../components/LoginForm";
import "../css/login.css";

import logo from "../images/ridersmiami-logo.png";
import moto from "../images/honda.png";

const Login = () => {
  return (
    <main className="login-page-riders">
      {/* =====================================================
          PANEL IZQUIERDO
         ===================================================== */}
      <section className="login-hero-riders">
        <div className="login-hero-content">
          <div className="login-kicker">
            Riders Miami Motorsports
          </div>

          <h1>
            Gestión comercial y logística para operar con más control.
          </h1>

          <p>
            Ventas, clientes, pagos, pedidos, reportes y seguimiento en una sola
            plataforma ordenada.
          </p>

          <div className="login-badges">
            <span>Ventas</span>
            <span>Pedidos</span>
            <span>Reportes</span>
          </div>
        </div>

        {/* ===================================================
            MOTO ANIMADA
            Entra desde la izquierda y queda a la derecha.
           =================================================== */}
        <div
          className="login-moto-stage"
          aria-hidden="true"
        >
          <img
            src={moto}
            alt=""
            className="login-moto-riders"
          />

          <div className="login-moto-shadow" />
        </div>
      </section>

      {/* =====================================================
          LOGIN
         ===================================================== */}
      <section className="login-panel-riders">
        <div className="login-card-riders">
          <div className="login-brand-riders">
            <img
              src={logo}
              alt="Riders Miami"
            />

            <div>
              <h2>
                Ingresar a Riders Miami
              </h2>

              <p>
                Sistema de gestión
              </p>
            </div>
          </div>

          <LoginForm />

          <div className="login-note-riders">
            Acceso seguro al panel operativo.
          </div>
        </div>
      </section>
    </main>
  );
};

export default Login;